import {
  GetPaywallDetailsFnReq,
  GetPaywallDetailsFnRes,
  PaywallFullDetails,
  PaywallRemoteConfigDetails,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { getValue, RemoteConfig } from 'firebase/remote-config';

export class GetPaywallDetailsInteractor {
  private readonly getPaywallDetailsFn = httpsCallable<
    GetPaywallDetailsFnReq,
    GetPaywallDetailsFnRes
  >(this.functions, 'getPaywallDetails');

  constructor(
    private readonly functions: Functions,
    private readonly remoteConfig: RemoteConfig,
  ) {}

  public async execute(): Promise<PaywallFullDetails> {
    const value = getValue(this.remoteConfig, 'paywall');
    const config = JSON.parse(value.asString());

    if (!this.validate(config)) {
      throw new Error('Invalid paywall config');
    }

    // Map paywall details in the backend
    const res = await this.getPaywallDetailsFn({ config });

    return res.data.config;
  }

  private validate(config: any): config is PaywallRemoteConfigDetails {
    return (
      // TODO: add more checks
      'offerId' in config
    );
  }
}
